import type { LoginForm } from "./Auth.typed";
import type { AuthModel } from "./AuthModel";
import type { User, LoginResponse } from "./Auth.typed";

export class AuthAdapter {
  authModel: AuthModel;

  constructor(authModel: AuthModel) {
    this.authModel = authModel;
  }

  async login(form: LoginForm): Promise<User | LoginResponse> {
    return await this.authModel.login(form);
  }
  async selectCompany(companyId: number): Promise<User> {
    return await this.authModel.selectCompany(companyId);
  }

  async resetRequest(form: LoginForm) {
    return await this.authModel.resetRequest(form);
  }

  async resetPassword(form: LoginForm) {
    return await this.authModel.resetPassword(form);
  }

  async logout() {
    return await this.authModel.logout();
  }

  async me(): Promise<LoginResponse> {
    return await this.authModel.me();
  }

  async verifyToken(form: LoginForm) {
    return await this.authModel.verifyToken(form);
  }
}
